module.exports = __webpack_public_path__ + "static/media/integrated_create_sample.e99c42af.png";